export default "__VITE_ASSET__B2B68E3n__"